import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from '../../../shared/services/service.service';
import { GetPickForServiceCarListResponse, GetRegisteredCarFaultsResponse, GetRegisteredCarFaultsModel } from '../../../shared/models/service.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';

@Component({
  templateUrl: 'service-voucher-start-add-comments.component.html',
  styleUrls: ['./service-voucher-start-add-comments.component.scss']
})
export class ServiceVoucherStartAddCommentsComponent implements OnInit {

  carListResponse: GetPickForServiceCarListResponse | null = null;
  registeredCarFaultsResponse: GetRegisteredCarFaultsResponse | null = null;
  comments: { text: string }[] = [];
  loading: boolean = true;

  constructor(
    private serviceService: ServiceService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router
  ) {}

  ngOnInit() {
    this.comments = this.activeUserLocalDataService.newServiceVoucherComments?.map(text => ({ text })) || [];
    const carId = this.activeUserLocalDataService.newServiceVoucherCarId;
  
    if (carId) {
      this.serviceService.getRegisteredCarFaults({ carId }).subscribe(
        (response) => {
          if (response && response.carFaults) {
            this.registeredCarFaultsResponse = response;
            this.registeredCarFaultsResponse.carFaults.forEach(fault => fault.picked = true);
          } else {
            console.warn('No car faults found for the selected car.');
          }
          this.loading = false;
        },
        (error) => {
          console.error('Error fetching registered car faults:', error);
          this.loading = false;
        }
      );
    } else {
      console.warn('Car ID is missing. Redirecting to /service-pick-car.');
      this.router.navigate(['/service-pick-car']);
      this.loading = false;
    }
  }

  addComment() {
    this.comments.push({ text: '' });
  }

  continueNextStep() {
    this.activeUserLocalDataService.newServiceVoucherComments = this.comments.map(c => c.text);
    this.activeUserLocalDataService.newServiceFixExistingCarFaultsList = this.registeredCarFaultsResponse?.carFaults
      .filter(fault => fault.picked)
      .map(fault => fault.carFaultId || 0) || [];
  
    if (this.activeUserLocalDataService.newServiceVoucherCarId) {
      this.router.navigate(['/service-voucher-start-pick-service']);
    } else {
      console.error('Car ID is missing. Navigation aborted.');
    }
  }

  navigateToServicePickCar() {
    this.router.navigate(['/service-pick-car']);
  }
}